'use strict';

import { applyHomeTheme, clampAnimationScore } from './home-themes.js';

const BADGE_META = {
    first_step:   { emoji: '💩', name: 'Premier pas',      desc: 'Tu as fait ton premier caca !' },
    usage_7d:     { emoji: '📆', name: 'Hebdo',            desc: '7 jours d’utilisation de l’app !' },
    usage_14d:    { emoji: '🗓️', name: 'Assidu',           desc: '14 jours d’utilisation de l’app !' },
    streak3:      { emoji: '🔥', name: 'Mini-série',       desc: '3 jours de suite avec au moins 1 caca !' },
    regular:      { emoji: '📅', name: 'Régulier',         desc: '7 jours de suite avec au moins 1 caca !' },
    champion:     { emoji: '🏆', name: 'Champion',         desc: '30 jours de suite avec au moins 1 caca !' },
    bi_daily_14:  { emoji: '⏱️', name: 'Métronome',        desc: '1 caca tous les 2 jours pendant 1 semaine' },
    month_active: { emoji: '🧭', name: 'Mois complet',      desc: '30 jours d’utilisation de l’app !' },
    triple_day:   { emoji: '🎯', name: 'Triplé',           desc: 'Faire 3 cacas (ou plus) en 1 jour !' },
    mouse_dropping: { emoji: '🐭', name: 'Crotte de souris', desc: 'Faire 3 cacas forme cailloux !' },
    elephant:     { emoji: '🐘', name: 'Elephant',         desc: 'Faire 3 cacas bien formes !' },
    haricot:      { emoji: '🫘', name: 'Le Haricot',       desc: 'Faire 3 cacas de taille minuscule !' },
    anaconda:     { emoji: '🐍', name: 'Anaconda',         desc: 'Faire 3 cacas de taille anaconda !' },
    eventail_taille: { emoji: '📏', name: 'Toute la Gamme', desc: 'Enregistrer les 4 tailles : minuscule, standard, imposant et anaconda !' },
    orion_fever:  { emoji: '☄️', name: 'Orion fever',      desc: 'Faire 3 cacas liquides en 2 jours !', hidden: true },
    chamalow:     { emoji: '🍬', name: 'Chamalow',         desc: 'Faire 3 cacas mous et cremeux en une semaine !', hidden: true },
    marathonnien: { emoji: '🏃', name: 'Marathonnien',     desc: 'Faire 30 cacas en 1 mois !', hidden: true },
    randonneur:   { emoji: '🥾', name: 'Randonneur',       desc: 'Faire au moins 3 cacas éloignés de plus de 50 km !' },
    globe_trotteur: { emoji: '🌍', name: 'Globe trotteur', desc: 'Faire au moins 3 cacas éloignés de plus de 500 km !' },
    mytho:        { emoji: '🤥', name: 'Mytho !',          desc: 'Faire 10 cacas mous et cremeux en 1 jour !', hidden: true },
    collector:    { emoji: '🌟', name: 'Collectionneur',   desc: '100 cacas au total !' },
    legend:       { emoji: '👑', name: 'Légende',          desc: '365 cacas au total !' },
};

const BADGE_POINTS = {
    first_step: 2,
    usage_7d: 4,
    usage_14d: 6,
    streak3: 4,
    regular: 8,
    champion: 20,
    bi_daily_14: 10,
    month_active: 12,
    triple_day: 5,
    mouse_dropping: 6,
    elephant: 6,
    haricot: 6,
    anaconda: 10,
    eventail_taille: 15,
    orion_fever: 8,
    chamalow: 8,
    marathonnien: 25,
    randonneur: 16,
    globe_trotteur: 30,
    mytho: -30,
    collector: 35,
    legend: 60,
};

const ALL_BADGE_KEYS = [
    'first_step',
    'usage_7d',
    'usage_14d',
    'streak3',
    'regular',
    'champion',
    'bi_daily_14',
    'month_active',
    'triple_day',
    'mouse_dropping',
    'elephant',
    'haricot',
    'anaconda',
    'eventail_taille',
    'collector',
    'legend',
    'orion_fever',
    'chamalow',
    'marathonnien',
    'randonneur',
    'globe_trotteur',
    'mytho'
];

let badgeQueue = [];
let isBadgeModalOpen = false;
let selectedBadgeKey = null;
let lastPassageId = null;
let dailyGoal = 1;
let _newsModalShown = false;
let _newsMarkInFlight = false;
let _newsMarked = false;
let _scoreTotalCount = 0;
let _scoreTotalStars = 0;
let _scoreBadges = [];
let _todayLoaded = false;
let _badgesLoaded = false;
let _homeReady = false;
let _pendingGeoPromise = null;
let _homeGroupNotifTimer = null;
const DEFAULT_LEVEL_THRESHOLDS = [0, 50, 120, 250, 400];
const DEFAULT_LEVEL_ANIMATION_SCORES = [1, 2, 3, 4, 5];
let _levelThresholds = [...DEFAULT_LEVEL_THRESHOLDS];
let _levelAnimationScores = [...DEFAULT_LEVEL_ANIMATION_SCORES];
const BG_MSG_SPIN_CLASS = 'bg-msg-spin';
const BG_MSG_PULSE_CLASS = 'bg-msg-pulse';
const BG_MSG_WOBBLE_CLASS = 'bg-msg-wobble';
let _activeMadnessScore = 0;

/* ===== POOP TYPES ===== */

const STOOL_SHAPES = [
    { key: 'rocky',       emoji: '🪨', short: 'Cailloux',  label: 'Comme des cailloux', sub: 'Bristol 1-2 · constipation' },
    { key: 'well_formed', emoji: '🥐', short: 'Bien formé', label: 'Bien formé',        sub: 'Bristol 3-4 · idéal' },
    { key: 'soft_creamy', emoji: '🍌', short: 'Crémeux',   label: 'Mou et crémeux',     sub: 'Bristol 5-6 · limite' },
    { key: 'liquid',      emoji: '💦', short: 'Liquide',   label: 'Liquide',            sub: 'Bristol 7 · diarrhée' },
];

const STOOL_COLORS = [
    { key: 'brown',        emoji: '🟤', short: 'Brun',       label: 'Brun classique',  sub: 'Normal' },
    { key: 'yellow_beige', emoji: '🟡', short: 'Jaune',      label: 'Jaune ou beige',  sub: 'Transit rapide / alimentation' },
    { key: 'green',        emoji: '🟢', short: 'Verdâtre',   label: 'Verdâtre',        sub: 'Transit rapide' },
    { key: 'red_black',    emoji: '🔴', short: 'Rouge/noir', label: 'Rouge ou noir',   sub: '⚠️ Consulter un médecin' },
];

const STOOL_SIZES = [
    { key: 'mini',   emoji: '🫘', short: 'Minuscule', label: 'Minuscule', sub: '< 5 cm · fragmenté' },
    { key: 'normal', emoji: '🌭', short: 'Standard',  label: 'Standard',  sub: '5-15 cm · calibre idéal' },
    { key: 'big',    emoji: '🥖', short: 'Imposant',  label: 'Imposant',  sub: '15-25 cm · belle pièce' },
    { key: 'giant',  emoji: '🐍', short: 'Anaconda',  label: 'Anaconda',  sub: '> 25 cm · légendaire' },
];

const STOOL_EFFORT_LABELS = {
    1: '😌 Ca coule tout seul',
    2: '😐 Un petit effort',
    3: '😤 J\'ai poussé fort',
};

let selectedShape = null;
let selectedColor = null;
let selectedSize = null;
let selectedEffort = null;

function syncBodyModalLock() {
    const openModalIds = ['poop-modal', 'badge-modal', 'news-modal'];
    const hasOpenModal = openModalIds.some(id => {
        const modal = document.getElementById(id);
        return Boolean(modal && !modal.hidden);
    });
    document.body.classList.toggle('modal-open', hasOpenModal);
}

/* ===== MAIN ACTION ===== */

function renderOptionChips(items, dataAttr, selectedKey) {
    return items.map(item => `
        <button type="button" class="poop-option${selectedKey === item.key ? ' selected' : ''}" data-${dataAttr}="${item.key}" title="${item.label} · ${item.sub}">
            <span class="poop-option-emoji">${item.emoji}</span>
            <span class="poop-option-label">${item.short}</span>
        </button>
    `).join('');
}

function updateSectionHint(hintId, item, prompt) {
    const el = document.getElementById(hintId);
    if (!el) return;
    if (item) {
        el.innerHTML = `<strong>${item.label}</strong> · ${item.sub}`;
        el.classList.add('is-set');
    } else {
        el.textContent = prompt;
        el.classList.remove('is-set');
    }
}

function renderShapeOptions() {
    const container = document.getElementById('poop-shape-options');
    if (!container) return;
    container.innerHTML = renderOptionChips(STOOL_SHAPES, 'shape', selectedShape);
    updateSectionHint('poop-shape-hint', STOOL_SHAPES.find(s => s.key === selectedShape), 'Choisis une forme');
}

function renderColorOptions() {
    const container = document.getElementById('poop-color-options');
    if (!container) return;
    container.innerHTML = renderOptionChips(STOOL_COLORS, 'color', selectedColor);
    updateSectionHint('poop-color-hint', STOOL_COLORS.find(c => c.key === selectedColor), 'Choisis une couleur');
}

function renderSizeOptions() {
    const container = document.getElementById('poop-size-options');
    if (!container) return;
    container.innerHTML = renderOptionChips(STOOL_SIZES, 'size', selectedSize);
    updateSectionHint('poop-size-hint', STOOL_SIZES.find(s => s.key === selectedSize), 'Choisis une taille');
}

function updateEffortLabel() {
    const labelEl = document.getElementById('poop-effort-label');
    if (!labelEl) return;
    if (!selectedEffort) {
        labelEl.textContent = 'Choisis ton effort';
        return;
    }
    labelEl.textContent = STOOL_EFFORT_LABELS[selectedEffort] || 'Choisis ton effort';
}

function updateMedicalAlert() {
    const alertEl = document.getElementById('poop-color-alert');
    if (!alertEl) return;
    alertEl.hidden = selectedColor !== 'red_black';
}

function updateQualificationConfirmState() {
    const confirmBtn = document.getElementById('poop-modal-confirm');
    if (!confirmBtn) return;
    confirmBtn.disabled = !(selectedShape && selectedColor && selectedSize && selectedEffort);
}

function resetQualificationForm() {
    selectedShape = null;
    selectedColor = null;
    selectedSize = null;
    selectedEffort = 2;

    const slider = document.getElementById('poop-effort-slider');
    if (slider) slider.value = '2';

    renderShapeOptions();
    renderColorOptions();
    renderSizeOptions();
    updateEffortLabel();
    updateMedicalAlert();
    updateQualificationConfirmState();
}

function selectShape(shape) {
    selectedShape = shape;
    renderShapeOptions();
    updateQualificationConfirmState();
}

function selectColor(color) {
    selectedColor = color;
    renderColorOptions();
    updateMedicalAlert();
    updateQualificationConfirmState();
}

function selectSize(size) {
    selectedSize = size;
    renderSizeOptions();
    updateQualificationConfirmState();
}

function setEffort(effort) {
    const parsed = Number(effort);
    selectedEffort = [1, 2, 3].includes(parsed) ? parsed : null;
    updateEffortLabel();
    updateQualificationConfirmState();
}

function getSelectedQualification() {
    if (!selectedShape || !selectedColor || !selectedSize || !selectedEffort) return null;
    return {
        shape: selectedShape,
        color: selectedColor,
        size: selectedSize,
        effort: selectedEffort,
    };
}

function addPassage() {
    const btn = document.getElementById('poo-btn');
    btn.disabled = true;
    btn.classList.add('bouncing');
    setTimeout(() => btn.classList.remove('bouncing'), 500);
    prepareGeoCapture();

    resetQualificationForm();
    document.getElementById('poop-modal').hidden = false;
    syncBodyModalLock();
}

async function confirmPassage(qualification = null) {
    document.getElementById('poop-modal').hidden = true;
    syncBodyModalLock();
    document.getElementById('poo-btn').disabled = false;

    launchConfetti();

    try {
        const body = new FormData();
        const geo = await consumeGeoCapture();
        if (qualification) {
            body.append('shape', qualification.shape);
            body.append('color', qualification.color);
            body.append('size', qualification.size);
            body.append('effort', String(qualification.effort));
        }
        if (geo) {
            body.append('geo_lat', String(geo.lat));
            body.append('geo_lng', String(geo.lng));
            body.append('geo_accuracy', String(geo.accuracy));
        }
        const resp = await fetch('api/add_passage.php', { method: 'POST', body });
        const data = await resp.json();

        await loadTodayData();
        await loadBadges();

        if (data.new_badges && data.new_badges.length > 0) {
            badgeQueue.push(...data.new_badges);
            if (!isBadgeModalOpen) showNextBadge();
        }
    } catch (e) {
        console.error('Erreur ajout passage:', e);
    }
}

function captureGeoNow() {
    if (!('geolocation' in navigator)) return Promise.resolve(null);

    return new Promise(resolve => {
        navigator.geolocation.getCurrentPosition(
            position => resolve({
                lat: position.coords.latitude,
                lng: position.coords.longitude,
                accuracy: position.coords.accuracy ?? 0,
            }),
            () => resolve(null),
            {
                enableHighAccuracy: false,
                timeout: 8000,
                maximumAge: 120000,
            }
        );
    });
}

function prepareGeoCapture() {
    _pendingGeoPromise = captureGeoNow();
}

async function consumeGeoCapture() {
    if (!_pendingGeoPromise) return captureGeoNow();

    const promise = _pendingGeoPromise;
    _pendingGeoPromise = null;
    try {
        return await promise;
    } catch (_) {
        return null;
    }
}

/* ===== DATA LOADING ===== */

async function loadTodayData() {
    try {
        const resp = await fetch('api/get_today.php');
        const data = await resp.json();
        lastPassageId = data.passages.length > 0 ? data.passages[0].id : null;
        updateTodayDisplay(data.count);
        updateStarsDisplay(data.total_stars);
        updateUndoButton(data.count);
        setBgStats(data.count, data.total_count, data.total_stars);
        _scoreTotalCount = Number(data.total_count || 0);
        _scoreTotalStars = Number(data.total_stars || 0);
    } catch (e) {
        console.error('Erreur chargement:', e);
    } finally {
        _todayLoaded = true;
        updateHomeLoadingState();
    }
}

async function deleteLastPassage() {
    if (!lastPassageId) return;

    const btn = document.getElementById('undo-btn');
    btn.disabled = true;

    try {
        const body = new FormData();
        body.append('id', lastPassageId);
        const resp = await fetch('api/delete_passage.php', { method: 'POST', body });
        const data = await resp.json();

        if (data.success) {
            await loadTodayData();
            await loadBadges();
        }
    } catch (e) {
        console.error('Erreur suppression:', e);
        btn.disabled = false;
    }
}

async function loadBadges() {
    try {
        const resp = await fetch('api/get_badges.php');
        const data = await resp.json();
        const badges = data.badges || [];
        _scoreBadges = badges;
        renderBadges(badges);
    } catch (e) {
        console.error('Erreur badges:', e);
    } finally {
        _badgesLoaded = true;
        updateHomeLoadingState();
    }
}

/* ===== DISPLAY UPDATES ===== */

function updateUndoButton(count) {
    const btn = document.getElementById('undo-btn');
    btn.hidden = !(count > 0);
    btn.disabled = false;
}

function updateTodayDisplay(count) {
    document.getElementById('today-count').textContent = count;
    const emojis = ['🚽', '💩', '💩💩', '💩💩💩', '🎉'];
    document.getElementById('today-emoji').textContent = emojis[Math.min(count, emojis.length - 1)];

    const label = document.getElementById('today-label');
    if (count >= dailyGoal) {
        label.textContent = `caca(s) aujourd'hui ✅`;
    } else {
        label.textContent = `caca(s) aujourd'hui · objectif : ${dailyGoal}`;
    }
}

function updateStarsDisplay(totalStars) {
    document.getElementById('stars-count').textContent = totalStars;
    const starsRow = document.getElementById('stars-row');
    const display = Math.min(totalStars, 10);
    starsRow.textContent = '⭐'.repeat(display);
    if (totalStars > 10) starsRow.textContent += `  +${totalStars - 10}`;
}

function renderBadges(unlockedBadges) {
    const grid = document.getElementById('badges-grid');
    const help = document.getElementById('badge-help');
    const unlockedKeys = new Set(unlockedBadges.map(b => b.badge_key));

    grid.innerHTML = ALL_BADGE_KEYS.map(key => {
        const meta = BADGE_META[key];
        const unlocked = unlockedKeys.has(key);
        const hiddenLocked = Boolean(meta.hidden && !unlocked);
        const displayName = hiddenLocked ? '???' : meta.name;
        const itemClasses = [
            'badge-item',
            unlocked ? 'unlocked' : 'locked',
            hiddenLocked ? 'hidden-locked' : '',
            meta.hidden && unlocked ? 'hidden-unlocked' : ''
        ].filter(Boolean).join(' ');
        const ariaLabel = hiddenLocked ? 'Badge : ???' : `${meta.name}: ${meta.desc}`;
        return `<button type="button" class="${itemClasses}" data-badge-key="${key}" data-unlocked="${unlocked ? '1' : '0'}" aria-label="${ariaLabel}">
            <span class="badge-emoji">${meta.emoji}</span>
            <span class="badge-name">${displayName}</span>
        </button>`;
    }).join('');

    const items = grid.querySelectorAll('.badge-item');
    items.forEach(item => {
        item.addEventListener('click', () => {
            selectedBadgeKey = item.dataset.badgeKey || null;
            items.forEach(el => el.classList.remove('selected'));
            item.classList.add('selected');
            updateBadgeHelp(selectedBadgeKey, item.dataset.unlocked === '1');
        });
    });

    if (selectedBadgeKey) {
        const selectedItem = grid.querySelector(`[data-badge-key="${selectedBadgeKey}"]`);
        if (selectedItem) {
            selectedItem.classList.add('selected');
            updateBadgeHelp(selectedBadgeKey, selectedItem.dataset.unlocked === '1');
            return;
        }
    }

    if (help) {
        help.textContent = 'Clique sur un badge pour voir comment le débloquer.';
    }
}

function updateBadgeHelp(key, unlocked) {
    const help = document.getElementById('badge-help');
    if (!help) return;

    const meta = BADGE_META[key];
    if (!meta) {
        help.textContent = 'Clique sur un badge pour voir comment le débloquer.';
        return;
    }

    if (meta.hidden && !unlocked) {
        help.textContent = '???';
        return;
    }

    const prefix = unlocked ? 'Déjà débloqué : ' : 'Pour le débloquer : ';
    help.textContent = `${meta.emoji} ${meta.name} - ${prefix}${meta.desc}`;
}

function updateScoreDisplay() {
    const totalEl = document.getElementById('score-total');
    const breakdownEl = document.getElementById('score-breakdown');
    const cardEl = document.getElementById('score-card');
    if (!totalEl || !breakdownEl || !cardEl) return;

    const score = computeScore(_scoreTotalCount, _scoreTotalStars, _scoreBadges);
    totalEl.textContent = `${score.total.toLocaleString('fr-FR')} pts`;
    breakdownEl.textContent =
        `💩 ${score.poopPoints.toLocaleString('fr-FR')} · ` +
        `📅 ${score.dailyBonusPoints.toLocaleString('fr-FR')} · ` +
        `🏅 ${score.badgePoints.toLocaleString('fr-FR')}`;
    cardEl.title =
        `💩 ${score.poopPoints} points (cacas) + ` +
        `📅 ${score.dailyBonusPoints} points (jours actifs) + ` +
        `🏅 ${score.badgePoints} points (badges)`;

    const levelProgress = computeLevelProgress(score.total, _levelThresholds);
    updateLevelCard(levelProgress);
    applyLevelBackgroundTheme(levelProgress.levelIndex);
}

function updateHomeLoadingState() {
    const body = document.body;
    if (!body || !body.classList.contains('child-view')) return;

    const scoreReady = _todayLoaded && _badgesLoaded;
    if (!scoreReady) {
        body.classList.add('home-loading');
        return;
    }

    // Affiche la UI uniquement quand le score complet peut être calculé.
    updateScoreDisplay();

    if (_homeReady) return;
    _homeReady = true;
    body.classList.remove('home-loading');

    const loadingEl = document.getElementById('boot-loading');
    if (loadingEl) loadingEl.hidden = true;
}

function normalizeThresholds(rawThresholds) {
    if (!Array.isArray(rawThresholds)) return [...DEFAULT_LEVEL_THRESHOLDS];
    const normalized = rawThresholds
        .map(value => Number(value))
        .filter(value => Number.isFinite(value))
        .map(value => Math.max(0, Math.floor(value)));

    normalized.push(0);
    const uniqueSorted = [...new Set(normalized)].sort((a, b) => a - b);
    return uniqueSorted.length >= 2 ? uniqueSorted : [...DEFAULT_LEVEL_THRESHOLDS];
}

function buildDefaultAnimationScores(levelCount) {
    const safeCount = Math.max(2, Number(levelCount || 0));
    const scores = [];
    for (let i = 0; i < safeCount; i++) {
        scores.push(Math.min(10, i + 1));
    }
    return scores;
}

function normalizeAnimationScores(rawScores, levelCount) {
    const defaults = buildDefaultAnimationScores(levelCount);
    if (!Array.isArray(rawScores)) return defaults;

    return defaults.map((fallback, index) => {
        const parsed = Number.parseInt(String(rawScores[index] ?? ''), 10);
        if (!Number.isFinite(parsed)) return fallback;
        return Math.max(1, Math.min(10, parsed));
    });
}

function getLevelAnimationScore(levelIndex) {
    const safeScores = normalizeAnimationScores(_levelAnimationScores, _levelThresholds.length);
    const safeIndex = Math.max(0, Math.floor(Number(levelIndex || 0)));
    return safeScores[safeIndex] || safeScores[safeScores.length - 1] || 1;
}

function computeLevelProgress(scoreTotal, thresholds) {
    const safeThresholds = normalizeThresholds(thresholds);
    const score = Math.max(0, Math.floor(Number(scoreTotal || 0)));
    let levelIndex = 0;

    for (let i = 0; i < safeThresholds.length; i++) {
        if (score >= safeThresholds[i]) {
            levelIndex = i;
        } else {
            break;
        }
    }

    const isMax = levelIndex >= safeThresholds.length - 1;
    const currentThreshold = safeThresholds[levelIndex];
    const nextThreshold = isMax ? null : safeThresholds[levelIndex + 1];
    let progressPct = 100;
    let remainingPoints = 0;

    if (!isMax && Number.isFinite(nextThreshold)) {
        const range = Math.max(1, nextThreshold - currentThreshold);
        progressPct = ((score - currentThreshold) / range) * 100;
        progressPct = Math.max(0, Math.min(100, progressPct));
        remainingPoints = Math.max(0, nextThreshold - score);
    }

    return {
        score,
        levelIndex,
        levelNumber: levelIndex + 1,
        currentThreshold,
        nextThreshold,
        progressPct,
        remainingPoints,
        isMax,
        thresholds: safeThresholds,
    };
}

function updateLevelCard(levelProgress) {
    const currentEl = document.getElementById('level-current');
    const nextEl = document.getElementById('level-next');
    const fillEl = document.getElementById('level-progress-fill');
    const textEl = document.getElementById('level-progress-text');
    const progressbarEl = document.getElementById('level-progressbar');
    if (!currentEl || !nextEl || !fillEl || !textEl || !progressbarEl) return;

    currentEl.textContent = `Niveau ${levelProgress.levelNumber}`;
    fillEl.style.width = `${levelProgress.progressPct.toFixed(1)}%`;
    progressbarEl.setAttribute('aria-valuenow', String(Math.round(levelProgress.progressPct)));

    if (levelProgress.isMax || levelProgress.nextThreshold === null) {
        nextEl.textContent = `Score actuel: ${levelProgress.score.toLocaleString('fr-FR')} pts`;
        textEl.textContent = 'Niveau max atteint 🎉';
        return;
    }

    const nextLevelNumber = levelProgress.levelNumber + 1;
    nextEl.textContent = `Prochain: niveau ${nextLevelNumber} à ${levelProgress.nextThreshold.toLocaleString('fr-FR')} pts`;
    textEl.textContent =
        `Il manque ${levelProgress.remainingPoints.toLocaleString('fr-FR')} point${levelProgress.remainingPoints > 1 ? 's' : ''} pour le niveau suivant.`;
}

function applyLevelBackgroundTheme(levelIndex) {
    const body = document.body;
    if (!body || !body.classList.contains('child-view')) return;

    const animationScore = clampAnimationScore(getLevelAnimationScore(levelIndex));
    body.dataset.homeMadness = String(animationScore);

    // Text/emoji background-message classes (bg-messages layer — not the chaos layer).
    body.classList.toggle(BG_MSG_SPIN_CLASS, animationScore >= 4);
    body.classList.toggle(BG_MSG_PULSE_CLASS, animationScore >= 6);
    body.classList.toggle(BG_MSG_WOBBLE_CLASS, animationScore >= 8);

    // Home-only body-level filters.
    body.classList.remove('home-madness-shake'); // legacy: never shake content
    body.classList.toggle('home-madness-neon', animationScore >= 9);
    body.classList.toggle('home-madness-apocalypse', animationScore >= 10);

    // Delegate colour + chaos layer to the shared theme module.
    applyHomeTheme(body, animationScore);

    if (animationScore !== _activeMadnessScore) {
        _activeMadnessScore = animationScore;
        restartBgMessages();
    }
}

function computeScore(totalCount, totalStars, badges) {
    const poopPoints = Math.max(0, Number(totalCount || 0));
    const dailyBonusPoints = Math.max(0, Number(totalStars || 0)); // 1 jour avec caca = +1 bonus
    const badgePoints = (badges || []).reduce((sum, badge) => {
        const key = badge?.badge_key;
        const points = BADGE_POINTS[key] ?? 5;
        return sum + points;
    }, 0);
    return {
        poopPoints,
        dailyBonusPoints,
        badgePoints,
        total: poopPoints + dailyBonusPoints + badgePoints,
    };
}

/* ===== BADGE MODAL ===== */

function showNextBadge() {
    if (badgeQueue.length === 0) { isBadgeModalOpen = false; return; }

    const key = badgeQueue.shift();
    const meta = BADGE_META[key];
    if (!meta) { showNextBadge(); return; }

    isBadgeModalOpen = true;
    document.getElementById('badge-modal-emoji').textContent  = meta.emoji;
    document.getElementById('badge-modal-title').textContent  = `${meta.name} débloqué !`;
    document.getElementById('badge-modal-desc').textContent   = meta.desc;

    const modal = document.getElementById('badge-modal');
    modal.hidden = false;
    syncBodyModalLock();
    launchConfetti();
}

function closeBadgeModal() {
    document.getElementById('badge-modal').hidden = true;
    syncBodyModalLock();
    setTimeout(showNextBadge, 300);
}

/* ===== CONFETTI ===== */

function launchConfetti() {
    const container = document.getElementById('confetti-container');
    const colors = ['#FF6B6B', '#4ECDC4', '#FFE66D', '#6C5CE7', '#FD79A8', '#6BCB77', '#FF9F43', '#74B9FF'];
    const emojiPieces = ['💩', '⭐', '✨', '🎉'];

    for (let i = 0; i < 45; i++) {
        setTimeout(() => {
            const el = document.createElement('div');
            el.classList.add('confetti-piece');

            if (Math.random() < 0.18) {
                el.textContent = emojiPieces[Math.floor(Math.random() * emojiPieces.length)];
                el.style.background = 'transparent';
                el.style.fontSize = (Math.random() * 14 + 14) + 'px';
                el.style.width = 'auto';
                el.style.height = 'auto';
            } else {
                const size = Math.random() * 10 + 5;
                el.style.width  = size + 'px';
                el.style.height = size + 'px';
                el.style.background = colors[Math.floor(Math.random() * colors.length)];
                el.style.borderRadius = Math.random() < 0.5 ? '50%' : '3px';
            }

            el.style.left = (Math.random() * 96 + 2) + 'vw';
            el.style.top  = '-30px';
            const duration = Math.random() * 2 + 1.8;
            el.style.animationDuration = duration + 's';

            container.appendChild(el);
            setTimeout(() => el.remove(), (duration + 0.1) * 1000);
        }, i * 28);
    }
}

/* ===== BURGER MENU ===== */

function toggleMenu() {
    const btn     = document.getElementById('burger-btn');
    const menu    = document.getElementById('nav-menu');
    const overlay = document.getElementById('nav-overlay');
    if (!btn || !menu || !overlay) return;
    const isOpen  = menu.classList.contains('open');
    if (isOpen) {
        closeMenu();
    } else {
        menu.classList.add('open');
        overlay.classList.add('open');
        btn.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        menu.setAttribute('aria-hidden', 'false');
    }
}

function closeMenu() {
    const btn     = document.getElementById('burger-btn');
    const menu    = document.getElementById('nav-menu');
    const overlay = document.getElementById('nav-overlay');
    if (!btn || !menu || !overlay) return;
    menu.classList.remove('open');
    overlay.classList.remove('open');
    btn.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
}

document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    closeMenu();
    closeNewsModal();
});

/* ===== LOGOUT ===== */

async function doLogout(e) {
    e.preventDefault();
    await fetch('api/auth/logout.php', { method: 'POST' });
    window.location.href = 'login';
}

/* ===== BACKGROUND ENCOURAGEMENT ===== */

const BG_TEMPLATES_SOBER = [
    '{name} progresse tranquillement.',
    'Rythme régulier pour {name}.',
    'Belle constance aujourd\'hui.',
    '{name} garde le cap.',
    'Progression propre et sereine.',
    'Mission du jour: validée calmement.',
];

const BG_TEMPLATES_FUN = [
    'Bravo {name} ! 💩',
    'Super caca ! 🌟',
    '{name} assure !',
    'Roi des cacas 👑',
    'Trop fort {name} !',
    'Caca power 💪',
    'Incroyable ! ✨',
    'Champion·ne ! 🏆',
    'Bravo bravo ! 🎉',
    'Quel talent {name} !',
    '{name} déchire !',
    'Merveilleux ! 🥰',
    'On est fiers de {name} !',
    'Quel exploit ! 🏅',
    'Fantastique ! 🚀',
    'Une légende ! 👏',
    'Waouw {name} !',
    'Trop bien ! 💛',
    'Top du top !',
    'Super héros·ïne ! 🦸',
    '{name} tu gères !',
    'Majestueux ! 👑',
    'Continue comme ça !',
    'Les intestins de {name} sont magiques !',
    'Caca de champion·ne !',
    'Hourra {name} ! 🎊',
    '{name}, tu rayonnes ! ☀️',
    'Quel rythme de star ! ⭐',
    'Un caca, un sourire ! 😄',
    'Forme olympique aujourd\'hui ! 🥇',
    '{name} en mode turbo ! ⚡',
    'Tu fais un carton ! 📣',
    'Équipe intestins au top ! 🫶',
    'Performance de légende ! 🔥',
    'On applaudit {name} ! 👏',
    'Magnifique énergie ! 💫',
    'Toujours plus fort·e ! 🚀',
    'Record battu dans nos cœurs ! 💖',
];

const BG_TEMPLATES_WILD = [
    'Orion fait un sprint de foufou pour fêter ça ! 🐕💨',
    'Orion, labrador x border collie, valide ce caca ! ✅🐾',
    'Même Orion le chien noir est impressionné ! 🖤🐶',
    'Alerte zoomies: Orion tourne en rond de joie ! 🌪️🐕',
    'Orion remue la queue à vitesse lumière ! ✨🐾',
    'Niveau énergie: Orion en mode turbo foufou ! ⚡🐶',
    'Le comité Orion approuve officiellement ce moment ! 🏅🐕',
    'Orion aboie: "encore une victoire intestinale !" 📣🐾',
    'Caca validé par Orion, expert en célébrations ! 🎉🐶',
    'Orion saute comme un kangourou noir de bonheur ! 🖤🦘',
    'Le duo labrador-border d\'Orion dit: magnifique ! 🐕👏',
    'Orion fait sa danse folle: mission réussie ! 💃🐾',
    'Orion patrouille et confirme: performance solide ! 🚓🐶',
    'Orion fonce, freine, refonce: c\'est la fête ! 🛞🐕',
    'Message d\'Orion: "tu gères grave aujourd\'hui !" 😄🐾',
];

const BG_TEMPLATES_DELIRIOUS = [
    'ALERTE COSMIQUE: les toilettes ouvrent un portail intergalactique 🚽🛸',
    'Le ministère des cacas déclare {name} légende nationale 📜💩',
    'La plomberie chante l\'hymne de la victoire en stéréo 🔊',
    'Le carrelage applaudit, les murs pleurent de joie 👏',
    'Trois univers parallèles confirment: c\'était épique 🌌',
    'Les étoiles font une ola pour {name} ⭐🌪️',
    'Le chrono a explosé, le style aussi, la gravité aussi 💥',
    'Niveau délire: cafetière qui parle + WC qui dansent ☕🚽',
    'Le geyser a pris un abonnement premium au chaos 💩🎟️',
    'Orion pilote désormais un vaisseau de fête canine 🐶🛸',
    '{name} vient de speedrun la gloire intestinale 🏁',
    'La timeline est cassée, le panache est intact ⏳🔥',
    'Les confettis demandent une pause syndicale 🎉',
    'Un tonnerre de "POPOPO" secoue la galaxie ⚡💩',
    'Le niveau 10 n\'est plus un niveau, c\'est une météo 🌪️',
    'Le comité scientifique confirme: c\'est absurdement magnifique 🧪✨',
    'On a perdu la raison, mais on a gagné le style 🤯',
    'Le chaos dit merci et reprend une tournée mondiale 🌍',
];

const MADNESS_TEMPLATES = {
    1: [
        '{name} déroule en douceur aujourd\'hui 🌼',
        'Session tranquille, style zen 🚽',
    ],
    2: [
        'Petit chaos contrôlé pour {name} 😌',
        'Ça flotte, ça brille, ça sent la victoire ✨',
    ],
    3: [
        'Les WC clignotent pour {name} 🚽✨',
        'Clap clap clap, standing ovation des toilettes 👏',
    ],
    4: [
        'Orion traverse l\'écran en mode sprint 🐶💨',
        'Défilé canin validé pour {name} 🐕',
    ],
    5: [
        '{name} est officiellement en mode turbo punchline ⚡',
        'Les slogans partent plus vite que la lumière 🚀',
    ],
    6: [
        'Alerte pluie légère de cacas ☔💩',
        '{name} déclenche une météo digestive locale 🌧️',
    ],
    7: [
        'Rave intestinale: pluie + néons + Orion 🎛️',
        'Le plafond applaudit en 💩 et en paillettes',
    ],
    8: [
        'Tempête canine confirmée, accroche-toi {name} 🌪️🐕',
        'Les messages font des loopings, c\'est la fête totale',
    ],
    9: [
        'Orage fécal majeur en approche ⚠️💩',
        '{name} pilote maintenant une tempête intestinale',
    ],
    10: [
        'GEYSER ACTIVÉ: niveau apocalyptique 💥💩',
        '{name} a cassé l\'échelle de la folie (et la plomberie)',
    ],
};

let _bgInterval = null;
let _bgName     = '';
let _bgStats    = null; // { todayCount, totalCount, totalStars }
const BG_TEXT_FX_BY_LEVEL = {
    1: ['calm'],
    2: ['calm', 'glow'],
    3: ['sway', 'glow'],
    4: ['wave', 'sway'],
    5: ['pop', 'wave'],
    6: ['orbit', 'pop'],
    7: ['jitter', 'orbit'],
    8: ['flip', 'jitter'],
    9: ['glitch', 'flip'],
    10: ['chaos', 'glitch', 'flip'],
};
const BG_EMOJI_FX_BY_LEVEL = {
    1: ['blink'],
    2: ['blink', 'sway'],
    3: ['sway', 'bounce'],
    4: ['bounce', 'orbit'],
    5: ['orbit', 'pulse'],
    6: ['pulse', 'shake'],
    7: ['shake', 'rocket'],
    8: ['rocket', 'flip'],
    9: ['glitch', 'flip'],
    10: ['warp', 'glitch', 'rocket'],
};
const BG_EMOJIS_BY_LEVEL = {
    1: ['🙂', '🌿', '✨'],
    2: ['🙂', '✨', '🚽'],
    3: ['🚽', '💩', '👏'],
    4: ['🐶', '🚽', '💩', '✨'],
    5: ['💩', '🚽', '⚡', '🎯'],
    6: ['💩', '🚽', '🌧️', '⚡'],
    7: ['💩', '🚽', '🎛️', '🌀', '🐕'],
    8: ['💩', '🐕', '🌪️', '🚽', '✨'],
    9: ['💩', '⚠️', '🚽', '🌩️', '🧨'],
    10: ['💩', '💥', '🚽', '🌪️', '🛸', '🤯'],
};

function pickRandom(items, fallback = '') {
    if (!Array.isArray(items) || items.length === 0) return fallback;
    return items[Math.floor(Math.random() * items.length)] || fallback;
}

function getBgFxProfile(madnessScore) {
    const safe = Math.max(1, Math.min(10, Number(madnessScore || 1)));
    const textFx = pickRandom(BG_TEXT_FX_BY_LEVEL[safe], 'calm');
    const emojiFx = pickRandom(BG_EMOJI_FX_BY_LEVEL[safe], 'blink');
    const emojiChance = Math.min(0.97, 0.18 + safe * 0.085);
    const emojiBurstMax = safe >= 10 ? 4 : safe >= 8 ? 3 : safe >= 5 ? 2 : 1;
    const emojis = BG_EMOJIS_BY_LEVEL[safe] || ['💩'];

    return {
        textFx,
        emojiFx,
        emojiChance,
        emojiBurstMax,
        emojis,
    };
}

function buildBgEmojiTrail(profile) {
    const count = 1 + Math.floor(Math.random() * Math.max(1, profile.emojiBurstMax));
    const parts = [];
    for (let i = 0; i < count; i++) {
        parts.push(pickRandom(profile.emojis, '💩'));
    }
    return parts.join(' ');
}

function getBgDensityProfile(madnessScore) {
    const safe = Math.max(1, Math.min(10, Number(madnessScore || 1)));
    const profiles = {
        1: { intervalMs: 3200, burstCount: 1,  burstSpacing: 280, perTick: 1 },
        2: { intervalMs: 2600, burstCount: 2,  burstSpacing: 240, perTick: 1 },
        3: { intervalMs: 2100, burstCount: 3,  burstSpacing: 220, perTick: 1 },
        4: { intervalMs: 1700, burstCount: 4,  burstSpacing: 180, perTick: 1 },
        5: { intervalMs: 1300, burstCount: 5,  burstSpacing: 150, perTick: 1 },
        6: { intervalMs: 950,  burstCount: 7,  burstSpacing: 125, perTick: 1 },
        7: { intervalMs: 700,  burstCount: 9,  burstSpacing: 95,  perTick: 2 },
        8: { intervalMs: 520,  burstCount: 12, burstSpacing: 76,  perTick: 2 },
        9: { intervalMs: 360,  burstCount: 15, burstSpacing: 62,  perTick: 3 },
        10:{ intervalMs: 240,  burstCount: 20, burstSpacing: 48,  perTick: 4 },
    };
    return profiles[safe] || profiles[1];
}

function restartBgMessages() {
    if (_bgInterval) {
        clearInterval(_bgInterval);
        _bgInterval = null;
    }

    const profile = getBgDensityProfile(_activeMadnessScore);
    for (let i = 0; i < profile.burstCount; i++) {
        setTimeout(() => spawnBgMsg(profile.perTick), i * profile.burstSpacing);
    }

    _bgInterval = setInterval(() => spawnBgMsg(profile.perTick), profile.intervalMs);
}

function setBgName(name) {
    _bgName = name || '';
    restartBgMessages();
}

function setBgStats(todayCount, totalCount, totalStars) {
    _bgStats = { todayCount, totalCount, totalStars };
}

function buildMsgPool() {
    const n    = _bgName || 'toi';
    const madness = Math.max(1, Math.min(10, Number(_activeMadnessScore || 1)));
    const pool = [...BG_TEMPLATES_SOBER];

    if (madness >= 3) {
        pool.push(...BG_TEMPLATES_FUN.slice(0, 12));
    }
    if (madness >= 5) {
        pool.push(...BG_TEMPLATES_FUN.slice(12));
    }
    if (madness >= 7) {
        pool.push(...BG_TEMPLATES_WILD);
    }
    if (madness >= 9) {
        pool.push(...BG_TEMPLATES_DELIRIOUS);
    }
    if (madness >= 10) {
        pool.push(...BG_TEMPLATES_DELIRIOUS);
    }

    if (madness <= 2) {
        const soberLines = (MADNESS_TEMPLATES[1] || []).concat(MADNESS_TEMPLATES[2] || []);
        soberLines.forEach(line => pool.push(line));
    } else if (madness <= 5) {
        (MADNESS_TEMPLATES[madness] || []).forEach(line => pool.push(line));
    } else if (madness <= 8) {
        for (let i = Math.max(3, madness - 2); i <= madness; i++) {
            (MADNESS_TEMPLATES[i] || []).forEach(line => pool.push(line));
        }
    } else {
        for (let i = 1; i <= 10; i++) {
            (MADNESS_TEMPLATES[i] || []).forEach(line => pool.push(line));
        }
    }

    if (_bgStats) {
        const { todayCount, totalCount, totalStars } = _bgStats;
        const s = x => x > 1 ? 's' : '';

        if (madness <= 2) {
            if (todayCount >= 1) {
                pool.push(`Aujourd'hui: ${todayCount} passage${s(todayCount)}.`);
            }
            if (totalCount >= 1) {
                pool.push(`Total actuel: ${totalCount} passage${s(totalCount)}.`);
            }
            if (totalStars >= 1) {
                pool.push(`Étoiles cumulées: ${totalStars}.`);
            }
        } else {
            if (todayCount === 1) {
                pool.push(`${n} a fait 1 caca aujourd'hui ! 💩`);
                pool.push(`1er caca du jour pour ${n} ! 🎯`);
            }
            if (todayCount >= 2) {
                pool.push(`${todayCount} cacas aujourd'hui ${n} ! 🔥`);
                pool.push(`${todayCount} cacas dans la journée, chapeau ! 🎩`);
            }
            if (totalCount >= 1) {
                pool.push(`${totalCount} caca${s(totalCount)} au compteur ! 💪`);
                pool.push(`Déjà ${totalCount} caca${s(totalCount)} en tout ! 🏆`);
            }
            if (totalCount >= 10) {
                pool.push(`${n} a passé la barre des ${Math.floor(totalCount / 10) * 10} ! 🚀`);
            }
            if (totalStars >= 1) {
                pool.push(`${totalStars} étoile${s(totalStars)} gagnée${s(totalStars)} ! ⭐`);
                pool.push(`${n} a ${totalStars} étoile${s(totalStars)} ⭐`);
            }
            if (totalStars >= 7) {
                pool.push(`Une semaine complète d'étoiles pour ${n} ! 🌟`);
            }
            if (totalStars >= 30) {
                pool.push(`${n}, 1 mois entier d'étoiles ! Incroyable 🏅`);
            }
        }

        if (madness >= 9) {
            pool.push(`Bilan live: ${todayCount} aujourd'hui, ${totalCount} au total, ${totalStars} étoiles ⭐`);
            pool.push(`Mode furie enclenché: ${n} roule sur le game intestinal 🛞💩`);
        }

        if (madness >= 10) {
            pool.push(`DELIRIUM MAX: ${n} déclenche ${todayCount}+${totalCount}+${totalStars} unités de chaos !`);
            pool.push(`Rapport officiel: geyser stable, panique festive en cours 🎉🚽`);
        }
    }

    return pool.map(t => t.replace(/\{name\}/g, n));
}

function spawnBgMsg(count = 1) {
    const container = document.getElementById('bg-messages');
    if (!container) return;

    const pool = buildMsgPool();
    const madness = Math.max(1, _activeMadnessScore);
    const spawnCount = Math.max(1, Math.floor(Number(count || 1)));

    for (let i = 0; i < spawnCount; i++) {
        const text = pool[Math.floor(Math.random() * pool.length)];
        const fxProfile = getBgFxProfile(madness);
        const el = document.createElement('span');
        el.className = 'bg-msg';

        const textEl = document.createElement('span');
        textEl.className = `bg-msg-text bg-msg-textfx-custom bg-msg-textfx-${fxProfile.textFx}`;
        textEl.textContent = text;
        el.appendChild(textEl);

        if (Math.random() < fxProfile.emojiChance) {
            const emojiEl = document.createElement('span');
            emojiEl.className = `bg-msg-emoji bg-msg-emojifx-${fxProfile.emojiFx}`;
            emojiEl.textContent = buildBgEmojiTrail(fxProfile);
            el.appendChild(emojiEl);
        }

        const left = 2 + Math.random() * 82;
        const dur = Math.max(4.2, 15.2 - (madness * 0.88) + Math.random() * 5.2);
        const fs = 0.9 + Math.random() * 1.15 + (madness * 0.06);
        const rot = (Math.random() - 0.5) * (14 + madness * 2.5);
        const op = Math.min(0.62, 0.15 + Math.random() * 0.15 + (madness * 0.024));
        const driftStart = (Math.random() - 0.5) * (8 + madness * 2.4);
        const driftEnd = (Math.random() - 0.5) * (26 + madness * 5.8);
        const textFxDur = Math.max(0.9, 2.4 - (madness * 0.09) + Math.random() * 1.1);
        const emojiFxDur = Math.max(0.75, 2.1 - (madness * 0.08) + Math.random() * 1.2);

        el.style.cssText =
            `left:${left}%; font-size:${fs}rem;` +
            `--dur:${dur}s; --rot:${rot}deg; --op:${op};` +
            `--drift-start:${driftStart.toFixed(2)}px; --drift-end:${driftEnd.toFixed(2)}px;` +
            `--text-fx-dur:${textFxDur.toFixed(2)}s; --emoji-fx-dur:${emojiFxDur.toFixed(2)}s;`;

        container.appendChild(el);
        setTimeout(() => el.remove(), (dur + 1) * 1000);
    }
}

function escHtml(str) {
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

function bindScoreCardNavigation() {
    const card = document.getElementById('score-card');
    if (!card || card.dataset.bound === '1') return;

    const openStats = () => {
        window.location.href = 'parent';
    };

    card.addEventListener('click', openStats);
    card.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openStats();
        }
    });
    card.dataset.bound = '1';
}

function bindHomeActions() {
    const pooBtn = document.getElementById('poo-btn');
    if (pooBtn) pooBtn.addEventListener('click', addPassage);

    const undoBtn = document.getElementById('undo-btn');
    if (undoBtn) undoBtn.addEventListener('click', deleteLastPassage);

    const shapeContainer = document.getElementById('poop-shape-options');
    if (shapeContainer) {
        shapeContainer.addEventListener('click', event => {
            if (!(event.target instanceof Element)) return;
            const shapeBtn = event.target.closest('[data-shape]');
            if (!shapeBtn) return;
            selectShape(shapeBtn.dataset.shape || '');
        });
    }

    const colorContainer = document.getElementById('poop-color-options');
    if (colorContainer) {
        colorContainer.addEventListener('click', event => {
            if (!(event.target instanceof Element)) return;
            const colorBtn = event.target.closest('[data-color]');
            if (!colorBtn) return;
            selectColor(colorBtn.dataset.color || '');
        });
    }

    const sizeContainer = document.getElementById('poop-size-options');
    if (sizeContainer) {
        sizeContainer.addEventListener('click', event => {
            const sizeBtn = event.target.closest('[data-size]');
            if (!sizeBtn) return;
            selectSize(sizeBtn.dataset.size || '');
        });
    }

    const effortSlider = document.getElementById('poop-effort-slider');
    if (effortSlider) {
        effortSlider.addEventListener('input', () => {
            setEffort(effortSlider.value);
        });
    }

    const skipBtn = document.getElementById('poop-modal-skip');
    if (skipBtn) skipBtn.addEventListener('click', () => confirmPassage(null));

    const confirmBtn = document.getElementById('poop-modal-confirm');
    if (confirmBtn) {
        confirmBtn.addEventListener('click', () => {
            const qualification = getSelectedQualification();
            if (!qualification) return;
            confirmPassage(qualification);
        });
    }

    const closeBadgeBtn = document.getElementById('badge-modal-close');
    if (closeBadgeBtn) closeBadgeBtn.addEventListener('click', closeBadgeModal);

    const closeNewsBtn = document.getElementById('news-close-btn');
    if (closeNewsBtn) closeNewsBtn.addEventListener('click', closeNewsModal);
}

/* ===== SETTINGS ===== */

async function loadSettings() {
    try {
        const resp = await fetch('api/get_settings.php');
        const data = await resp.json();

        dailyGoal = data.daily_goal || 1;
        _levelThresholds = normalizeThresholds(data.level_thresholds);
        _levelAnimationScores = normalizeAnimationScores(data.level_animation_scores, _levelThresholds.length);

        if (data.child_name) {
            const safe = data.child_name.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
            document.getElementById('main-title').innerHTML =
                `MyPoo · ${safe} <img class="brand-logo" src="static/icons/myPoo-logo.jpeg" alt="Logo MyPoo">`;
        }

        setBgName(data.child_name || '');

        const seenServer = Boolean(data.announcement_20260316_seen);
        if (!seenServer) {
            setTimeout(showNewsModal, 450);
        }
        updateHomeLoadingState();
    } catch (e) {
        console.error('Erreur settings:', e);
    }
}

function showNewsModal() {
    if (_newsModalShown) return;
    const modal = document.getElementById('news-modal');
    if (!modal) return;
    _newsModalShown = true;
    modal.hidden = false;
    syncBodyModalLock();
}

function closeNewsModal() {
    const modal = document.getElementById('news-modal');
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    syncBodyModalLock();
    markNewsAsSeen();
}

async function markNewsAsSeen() {
    if (_newsMarked || _newsMarkInFlight) return;
    _newsMarkInFlight = true;
    try {
        const resp = await fetch('api/save_settings.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ announcement_20260316_seen: 1 }),
        });
        if (resp.ok) _newsMarked = true;
    } catch (e) {
        // Silent: if save fails, popup may reappear on next login
    } finally {
        _newsMarkInFlight = false;
    }
}

async function loadAppVersion() {
    const el = document.getElementById('app-version');
    if (!el) return;

    try {
        const resp = await fetch('api/get_version.php', { cache: 'no-store' });
        if (!resp.ok) return;
        const data = await resp.json();
        const version = String(data.version || '').trim();
        if (version) {
            el.textContent = `V${version}`;
        }
    } catch (_) {
        // Silent fallback to default text in HTML
    }
}

function updateGroupMessageNotificationUI(inGroup, unreadCount) {
    const notifLink = document.getElementById('home-group-notif');
    const countEl = document.getElementById('home-group-notif-count');
    if (!notifLink || !countEl) return;

    if (!inGroup) {
        notifLink.hidden = true;
        notifLink.classList.remove('has-unread');
        return;
    }

    const count = Math.max(0, Number(unreadCount || 0));
    countEl.textContent = count > 99 ? '99+' : String(count);
    notifLink.hidden = false;
    notifLink.classList.toggle('has-unread', count > 0);
    notifLink.setAttribute(
        'aria-label',
        count > 0
            ? `Voir les messages du groupe (${count} non lu${count > 1 ? 's' : ''})`
            : 'Voir les messages du groupe'
    );
}

async function loadGroupMessageNotification() {
    try {
        const resp = await fetch('api/groups/messages_unread_count.php', { cache: 'no-store' });
        if (!resp.ok) {
            updateGroupMessageNotificationUI(false, 0);
            return;
        }
        const data = await resp.json();
        updateGroupMessageNotificationUI(Boolean(data.in_group), Number(data.unread_count || 0));
    } catch (_) {
        updateGroupMessageNotificationUI(false, 0);
    }
}

function startGroupMessageNotificationRefresh() {
    if (_homeGroupNotifTimer) {
        clearInterval(_homeGroupNotifTimer);
    }

    loadGroupMessageNotification();
    _homeGroupNotifTimer = setInterval(() => {
        if (document.visibilityState !== 'visible') return;
        loadGroupMessageNotification();
    }, 30000);

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            loadGroupMessageNotification();
        }
    });
}

function isAdminRole(role) {
    return role === 'admin' || role === 'super_admin';
}

/* ===== INIT ===== */

async function init() {
    await window.authReady;
    bindHomeActions();
    bindScoreCardNavigation();
    if (isAdminRole(window.currentUser?.role)) {
        document.body.classList.add('is-admin');
    }
    loadAppVersion();
    startGroupMessageNotificationRefresh();
}

loadSettings();
loadTodayData();
loadBadges();
init();
